var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.013,
    height: 20,
    viewBox: "0 0 29.013 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(1.597 1.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M33.874,15.75H15a2.25,2.25,0,0,1,0-4.5H33.874a2.25,2.25,0,0,1,0,4.5Z",
    transform: "translate(-8.709 -12.451)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M33.874,26.25H15a2.25,2.25,0,0,1,0-4.5H33.874a2.25,2.25,0,0,1,0,4.5Z",
    transform: "translate(-8.709 -15.611)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M33.874,36.75H15a2.25,2.25,0,0,1,0-4.5H33.874a2.25,2.25,0,0,1,0,4.5Z",
    transform: "translate(-8.709 -18.772)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    d: "M1-1.5A2.5,2.5,0,1,1-1.5,1,2.5,2.5,0,0,1,1-1.5Z",
    transform: "translate(-0.097 -0.389)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    d: "M1.049-1.5A2.549,2.549,0,1,1-1.5,1.049,2.551,2.551,0,0,1,1.049-1.5Z",
    transform: "translate(0 7.34)",
    fill: "#00828b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M1-1.5A2.5,2.5,0,1,1-1.5,1,2.5,2.5,0,0,1,1-1.5Z",
    transform: "translate(-0.097 14.611)",
    fill: "#00828b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.51c25476be185a7ae30d0f8c70240e47.svg";
export { ForwardRef as ReactComponent };